module.exports = __webpack_public_path__ + "media/images/icons/folder-f6c69126f9eb6b4c6f4bf7870ccc6d2d.svg";